// extracted by mini-css-extract-plugin
export default {"PasswordResetPage":"PasswordResetPage_PasswordResetPage__y0JO-","pageRow":"PasswordResetPage_pageRow__X1KW9"};